import { DmsBaseComponent } from '#components/dms/common/base';
import { DmsFormItemType } from '#components/dms/form/formItemSrc';

export const DmsWrapperConstructor = DmsBaseComponent.extend({
	name: 'DmsWrapper',
	props: {
		showLabel: { type: Boolean, default: true },
		span: Number,
		wrapp: { type: Boolean, default: true },
		validationProperty: String,
		validationRules: [Object, Array],
		required: { type: Boolean, default: false },
		noLabelAlign: { type: Boolean, default: false }, /* Adds a label-sized margin-top. Use to align item if it's not a direct child of dms-row. */
	},
	computed: {
		spanNumber(): number {
			return this.span ? this.span : 24;
		},
		hasSpan(): boolean {
			return !!this.span;
		},
		columnClass(): string {
			const classes = [];
			if (this.hasSpan && this.wrapp) {
				classes.push('el-col');
				if (this.isFormMode) {
					classes.push('el-col-24');
					classes.push(`el-col-md-${this.span}`);
				} else {
					classes.push(`el-col-${this.span}`);
				}
			}
			return classes.join(' ');
		},

		getClass(): DmsWrapperClassType | [DmsWrapperClassType, any] {
			const baseClass = { 'frm-group': this.wrapp, 'is-required': this.required, 'frm-item-label-margin': this.noLabelAlign };
			return this.hasSpan ? baseClass : [baseClass, this.columnClass];
		},

		renderCol(): boolean {
			return this.hasSpan;
		},

		xs(): number | undefined {
			return this.hasSpan ? 24 : undefined;
		},

		isFormEditable(): boolean {
			return this.isCreateMode || this.isEditMode;
		},

		formItem(): DmsFormItemType {
			return this.$refs.formItem as DmsFormItemType;
		},
	},
});

type DmsWrapperClassType = { 'frm-group': boolean, 'is-required': boolean, 'frm-item-label-margin': boolean };
export type DmsWrapperType = InstanceType<typeof DmsWrapperConstructor>;

// eslint-disable-next-line
export default DmsWrapperConstructor;
